import type { Instance } from "@gadgetinc/mobx-quick-tree";
import { DateTime } from "luxon";
import { WorkspacePageType } from "../../WorkspacePageType";
import type { ShopifyBaseConfig } from "../../connections/shopify/ShopifyBaseConfig";
import { createProblemFinder } from "../createProblemFinder";

export const ShopifyConfigProblems = createProblemFinder<Instance<typeof ShopifyBaseConfig>>(
  {
    apiDeprecationDate: {
      datetime: (_value) => {
        return {
          earliest: DateTime.now(),
          message: `Upgrade Shopify connection API version`,
        };
      },
    },
  },
  {
    name: "Shopify Configuration",
    tabType: WorkspacePageType.ShopifyConnectionsAPIUpgrade,
    fullMessages: false,
  }
);
